import React from "react";
import { useAppDispatch } from "../../../redux/hook";
import _ from "lodash";
import { showOrderStatus } from "../../../redux/actions";
import Order from "../../Order/Order.view";
import { Box } from "@mui/material";
import Styles from "../../PastOrders/PastOrders.styles";
type OrderModalBodyProps = {
  orderStatus: any;
  orders: any;
};

export default function OrderModalBody({
  orders,
}: OrderModalBodyProps) {
  const dispatch = useAppDispatch();

  return (
    <Box sx={Styles.container}>
      {!_.isEmpty(orders) &&
        _.keys(orders)
          .sort(
            (a, b) =>
              new Date(orders[b].date).getTime() -
              new Date(orders[a].date).getTime()
          )
          .map((key) => {
            const order = orders[key];

            return (
              <Box
                sx={{ width: "100%" }}
                key={key}
                onClick={() => dispatch(showOrderStatus(order.chargeId))}
              >
                <Order order={order} />
              </Box>
            );
          })}
    </Box>
  );
}
